import { TranslateService } from '@ngx-translate/core';
import { handleEmptyValues, genericStringFormatter, restorePointRender, storageRender, ongoingRenderDeletedVapps } from '../../dataprotection-common/common-renderers';

export function getDatatableConfig(translate:TranslateService) {
    return {
        dom: 'Bfrtip',
        columns: [
            { "data": null, "width": "4%", "title": ''},
            { "data": "name", "width": "40%", "title": translate.instant('dpsModule.deletedVapps.grid.header.vapp')},
            { "data": "restorePointCount", "width": "26%", "title": translate.instant('dpsModule.deletedVapps.grid.header.restorePoints')},
            { "data": null, "width": "30%", "title": translate.instant('dpsModule.deletedVapps.grid.header.storage')}
        ],
        columnDefs: [
            {
                "targets": [ 0 ],
                "orderable": false,
                "mRender": function ( data, type, row ) {
                    return ongoingRenderDeletedVapps(data, type, row);
                }
            },
            {
                "targets": [ 1 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        return genericStringFormatter(handleEmptyValues(row.name));
                    }
                    return handleEmptyValues(row.name);
                }
            },
            {
                "targets": [ 2 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        return restorePointRender(data, type, row);
                    }
                    return ((row && row.statistics && row.statistics.restorePointCount) ? row.statistics.restorePointCount : 0);
                }
            },
            {
                "targets": [ 3 ],
                "mRender": function ( data, type, row ) {
                    if ( type === 'display' ) {
                        return storageRender(data, type, row);
                    }
                    return ((row && row.statistics && row.statistics.storageConsumed) ? row.statistics.storageConsumed : 0);
                }
            }
        ],
        "autoWidth": false,
        "oLanguage": {
            "sSearch": "",
            "sEmptyTable": translate.instant('dpsModule.deletedVapps.grid.message.emptyTable'),
            "sInfoEmpty": translate.instant('dpsModule.deletedVapps.grid.message.infoEmpty')
        },
        "scrollY":        "50vh",
        "scrollCollapse": true,
        "paging":         false,
        "bFilter": true,
        'bDestroy': true,
        "bUseRendered": false,
        "order": [[ 0, "desc" ]],
        "rowCallback": function( row, data ) {
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/deleted-vapps/deleted-vapps.dt.config.ts